import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=5df284d2&scoped=true&"
import script from "./task-list.vue?vue&type=script&lang=js&"
export * from "./task-list.vue?vue&type=script&lang=js&"
import style0 from "./task-list.vue?vue&type=style&index=0&id=5df284d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df284d2",
  null
  
)

export default component.exports